import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWalletConnection } from "../../utility/useWalletConnection";
import { useData } from "../../utility/useData";
import { useDispatch } from "react-redux";
import { getIsDrawn } from "../../pages/Home/store";
import ConnectButton from "../connect-button/ConnectButton";
import PoolListFilter from "../pool-list-filter/PoolListFilter";
import MyPools from "./Mypools";
import Allpools from "./Allpools";
import Endedpools from "./Endedpools";

const LeftMenu = ({ handleFlyToCity, poolCount, pools }) => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const {
    isConnected,
    connectedWalletInfo,
    address,
    chainId,
    signerVars,
    unSignerVars,
    mockVRF,
    errorMessage,
    clearError,
    open,
    connect,
    disConnect,
  } = useWalletConnection();

  const {
    decimals,
    initialResultMsg,
    initialData,
    reRender,
    poolData,
    showPoolDetail,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
  } = useData();

  const searchVesmap = useRef();
  const menuMyPoolStatus = sessionStorage.getItem("menu-my-pool");
  const menuAllPoolStatus = sessionStorage.getItem("menu-all-pool");
  const menuEndedPoolStatus = sessionStorage.getItem("menu-ended-pool");

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingJoined, setIsLoadingJoined] = useState(false);

  const [filteredAllPools, setFilteredAllPools] = useState();
  const [filteredmyJoinedPools, setFilteredMyJoinedPools] = useState();
  const [searchResult, setSearchResult] = useState([]);

  const [menuMyPools, setMenuMyPools] = useState(
    menuMyPoolStatus ? JSON.parse(menuMyPoolStatus) : true
  );
  const [menuAllPools, setMenuAllPools] = useState(
    menuAllPoolStatus ? JSON.parse(menuAllPoolStatus) : true
  );
  const [menuEndedPools, setMenuEndedPools] = useState(
    menuEndedPoolStatus ? JSON.parse(menuEndedPoolStatus) : true
  );

  const [visibleFilter, setVisibleFilter] = useState({});

  const toggleFilter = (filterId) => {
    setVisibleFilter((prevState) => ({
      ...prevState,
      [filterId]: !prevState[filterId],
    }));
  };

  const toggleMenuItem = (menu) => {
    if (menu === "mypool") {
      setMenuMyPools((prevState) => !prevState);
      sessionStorage.setItem("menu-my-pool", !menuMyPools);
    }
    if (menu === "allpool") {
      setMenuAllPools((prevState) => !prevState);
      sessionStorage.setItem("menu-all-pool", !menuAllPools);
    }
    if (menu === "ended") {
      setMenuEndedPools((prevState) => !prevState);
      sessionStorage.setItem("menu-ended-pool", !menuEndedPools);
    }
  };

  const searchCity = () => {
    let word = searchVesmap.current.value.toLowerCase();
    if (word.length > 0) {
      let result = pools.filter((f) => f.name.toLowerCase().includes(word));
      setSearchResult(result);
    } else {
      setSearchResult([]);
    }
  };

  const addPoolToNewPools = (status, pool, newPools) => {
    if (!newPools[status]) {
      newPools[status] = [];
    }
    newPools[status].push(pool);
  };

  const sortedPool = (pool) => {
    const sortedKeys = [
      "Coming Soon",
      "Join",
      "Locked",
      "Raffle",
      "Claim",
      "Ended",
      "Refund",
    ];
    const newSortedPool = {};
    sortedKeys.forEach((acc) => {
      if (pool[acc]) newSortedPool[acc] = pool[acc];
    });
    console.log("newSortedPool", newSortedPool);
    return newSortedPool;
  };

  const getJoinedPools = async (allPools) => {
    const getInfo = await unSignerVars.contract.getInfo(1, address);
    const userJoinedPoolCount = Number(getInfo.userJoinedPoolCount);
    let userPools = [];

    if (userJoinedPoolCount > 0) {
      setIsLoadingJoined(true);
    }

    for (let i = 0; i < userJoinedPoolCount; i++) {
      const joinedPoolId = Number(
        await unSignerVars.contract.joinedPools(address, i)
      );
      allPools.forEach((pool, index) => {
        if (pool.poolId === joinedPoolId) {
          userPools.push(allPools[index]);
        }
      });
    }

    userPools.reverse(function (a, b) {
      return a.poolId - b.poolId;
    });

    let userJoinedPools = {};
    userPools.forEach((pool) => {
      const status = statusText(pool.status);
      addPoolToNewPools(status, pool, userJoinedPools);
    });
    console.log("Joined Pools:", userJoinedPools);
    setFilteredMyJoinedPools(sortedPool(userJoinedPools));
    setIsLoadingJoined(false);
  };

  const getAllPools = async () => {
    let activePools = {};
    pools.forEach((pool) => {
      const status = statusText(pool.status);
      addPoolToNewPools(status, pool, activePools);
    });
    setFilteredAllPools(sortedPool(activePools));
    console.log("activePools", filteredAllPools);
  };

  useEffect(() => {
    console.log(poolCount, pools);
    if (poolCount >= 0) {
      if (pools.length > 0) {
        const fetchData = async () => {
          isConnected && (await getJoinedPools(pools));
          await getAllPools();
        };
        fetchData();
      }
      setIsLoading(false);
    }
  }, [poolCount, pools]);

  useEffect(() => {
    if (poolCount >= 0) {
      if (pools.length > 0) {
        getJoinedPools(pools);
      }
    }
  }, [reRender]);

  return (
    <>
      <div className="search-item">
        <input
          type="text"
          className="search-in"
          placeholder="Search in Vesmap"
          ref={searchVesmap}
          onChange={() => searchCity()}
        />
        {/* <img src={filter} alt="" /> */}
      </div>
      {searchResult.length > 0 && (
        <div className="search-list">
          <div className="in">
            {searchResult.map((pool) => (
              <Link
                key={pool.poolId}
                to={search}
                onClick={() => {
                  handleFlyToCity(pool);
                  setSearchResult([]);
                  searchVesmap.current.value = "";
                }}
              >
                {pool.name} ({statusText(pool.status)})
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="container-m">
        {isConnected && (
          <MyPools
            menuMyPools={menuMyPools}
            isLoadingJoined={isLoadingJoined}
            filteredmyJoinedPools={filteredmyJoinedPools}
            toggleMenuItem={toggleMenuItem}
            toggleFilter={toggleFilter}
            visibleFilter={visibleFilter}
            handleFlyToCity={handleFlyToCity}
          />
        )}
        <>
          <Allpools
            menuAllPools={menuAllPools}
            isLoading={isLoading}
            filteredAllPools={filteredAllPools}
            toggleMenuItem={toggleMenuItem}
            toggleFilter={toggleFilter}
            visibleFilter={visibleFilter}
            handleFlyToCity={handleFlyToCity}
          />
          <Endedpools
            menuAllPools={menuAllPools}
            isLoading={isLoading}
            filteredAllPools={filteredAllPools}
            toggleFilter={toggleFilter}
            visibleFilter={visibleFilter}
            handleFlyToCity={handleFlyToCity}
          />
        </>
      </div>
    </>
  );
};

export default LeftMenu;
